<app-search-view (searchEmit)="search($event)" class="mb-4" [searchText] ="searchText" ></app-search-view>
<br>
<app-product-list [dataExist]="true" [dataProd]="searchResult"></app-product-list>